import { ActionCreator } from "redux";
import {
    PatientIndividualInformationDto,
    HealthCardAcquisitionType
} from "../../dtos/KioskDtos.dtos";
import {
  GET_PATIENT_INFO,
  POST_PATIENT_INFO,
  PUT_PATIENT_INFO} from "./constant";
import {
  GetPatientInfoFromServerAction,
  PostPatientInfoToServerAction,
  PutPatientInfoToServerAction} from "./types";

export const getPatientInfoFromServer: ActionCreator<GetPatientInfoFromServerAction> = (healthCardNumber: string, acquisitionType: HealthCardAcquisitionType) => ({
    type: GET_PATIENT_INFO,
    payload: {
        healthCardNumber,
        acquisitionType
    },
});

export const postPatientInfoToServer: ActionCreator<PostPatientInfoToServerAction> = (patientInfo: PatientIndividualInformationDto) => ({
    type: POST_PATIENT_INFO,
    payload: {
        patientInfo
    },
});

export const putPatientInfoToServer: ActionCreator<PutPatientInfoToServerAction> = (patientInfo: PatientIndividualInformationDto) => ({
    type: PUT_PATIENT_INFO,
    payload: {
        patientInfo
    },
});


// WEBPACK FOOTER //
// ./src/sagas/PatientInfo/actions.ts